import React from 'react';

interface IIconProps {
  className?: string;
}

const Icon = (props: IIconProps) => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path stroke="#4468FF" strokeWidth="3" d="M14 14h20l5 7.63L24 38 9 21.63zM9 21.5h30" />
      </g>
    </svg>
  );
};

export default React.memo(Icon);
